import axios from '@/api/axiosInstance';

export default async function getTask(taskId) {
  const response = await axios({
    method: 'get',
    url: `${process.env.NEXT_PUBLIC_API}/tasks/${taskId}`,
  });
  return response.data;
}
